// KL - aircond repair.
const content = {
    slug: 'aircond-repair',
    title: (c) => `Aircond Repair KL | Diagnosis ${c.money(c.tables.repairDiagnosis)}, Quote Before Work`,
    description: (c) =>
        `Aircond repair in Kuala Lumpur. Diagnosis visit ${c.money(c.tables.repairDiagnosis)}; the technician finds the fault and quotes the fix before any work starts.`,
    eyebrow: 'KL · Aircond repair',
    h1: 'Aircond Repair in Kuala Lumpur',
    lead: (c) =>
        `Not cold, not switching on, blinking lights or water dripping? Book a diagnosis for ${c.money(c.tables.repairDiagnosis)}. You get a clear quote for the repair and decide before anything is done.`,
    image: 'blog/living/aircon-pcb-repair.jpg',
    imageAlt: 'Technician repairing an aircond control board',
    facts: ['Fixed diagnosis fee', 'Quote before repair', 'All major brands'],
    priceTitle: 'Book a diagnosis',
    priceIntro: 'Choose the closest problem - it helps the technician bring the right parts.',
    panel: {
        type: 'repair',
        problems: ['Not cold', 'Not switching on', 'Blinking light / error', 'Water dripping', 'Noisy', 'Not sure'],
    },
    sections: [
        {
            title: 'Common aircond faults in KL homes',
            cards: [
                { title: 'Blinking timer light', body: 'Most brands show a fault by blinking a light on the indoor unit. Often a sensor, a blocked drain switch or a board issue.' },
                { title: 'Outdoor unit not running', body: 'Indoor fan blows but the air isn\'t cold. Usually a capacitor or contactor - quick to replace.' },
                { title: 'Tripping after storms', body: 'Power surges during thunderstorms can damage boards and trip the breaker. A surge protector is worth fitting after the repair.' },
                { title: 'Rusted outdoor brackets', body: 'Old brackets on condo ledges and terrace walls rust in the rain and make units vibrate. Replaced before they fail.' },
            ],
            cardColumns: 2,
        },
        {
            title: 'Brands we see most',
            tone: 'muted',
            paragraphs: [
                'Daikin, Panasonic, Acson, York, Midea, Samsung, LG, Gree and Hisense - the brands you find in most Malaysian homes. Tell us the brand and the error code or blink pattern when you book.',
            ],
        },
    ],
    faqs: [
        {
            question: 'How much does aircond repair cost in KL?',
            answer: (c) => `The diagnosis visit costs ${c.money(c.tables.repairDiagnosis)}. The repair is quoted after the technician finds the fault - parts like capacitors are inexpensive; boards and compressors cost more.`,
        },
        {
            question: 'My aircond timer light is blinking - what does it mean?',
            answer: 'It is the unit reporting a fault. The pattern means different things for each brand; count the blinks and tell us the brand when you book.',
        },
        {
            question: 'Is it worth repairing an old aircond?',
            answer: 'Small parts, yes. A failed compressor on an old R22 non-inverter unit usually costs close to a new inverter unit - the technician will tell you honestly.',
        },
    ],
    schema: {
        name: 'Aircond Repair in Kuala Lumpur',
        serviceType: 'Air conditioner repair',
        offers: (c) => [{ name: 'Aircond repair diagnosis visit', price: c.tables.repairDiagnosis }],
    },
}

export default content
